import React from "react";
import { Helmet } from "react-helmet-async";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AppBar from "@mui/material/AppBar";
import Container from "../../../common/Container";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import twiga from "../../../assets/images/twiga.jpg";

const Twiga = () => {
  return (
    <Box bgcolor={"#fff"}>
      <Helmet>
        <title>
          {" "}
          Use Case: Supply chain optimization and digital marketplace use case
        </title>
      </Helmet>
      <AppBar
        position={"sticky"}
        elevation={0}
        sx={{
          backgroundColor: "#fff",
          padding: "10px 0px",
        }}
      >
        <Container paddingY={{ xs: 1 / 2, sm: 1 }}>
          <Header />
        </Container>
      </AppBar>
      <Container bgcolor={"#fff"}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"flex-start"}
          flexWrap={"wrap"}
        >
          <Box
            width={{ xs: "100%", sm: "80%" }}
            padding={{ xs: "25% 0% 10% 0%", sm: "2% 0%" }}
            marginLeft={{ xs: "0%", sm: "0%" }}
          >
            <Box display={"flex"} alignItems={"center"} marginBottom={"2%"}>
              <Box
                component="img"
                height={{ xs: "28vh", sm: "550px" }}
                width={{ xs: "100%", sm: "100%" }}
                marginTop={{ xs: "20%", sm: "0%" }}
                src={twiga}
                alt={"twiga_img"}
                sx={{
                  objectFit: "cover",
                  borderRadius: "30px",
                }}
              />
            </Box>
            <Typography
              variant="h4"
              color={"#39484E"}
              fontWeight={700}
              paddingBottom={{ xs: "2%", sm: "1%" }}
              textAlign={"left"}
            >
              CASE 1: Twiga Foods
            </Typography>
            <Typography
              variant="h6"
              color={"#4f4f4f"}
              fontWeight={700}
              paddingBottom={{ xs: "5%", sm: "2%" }}
              textAlign={"left"}
            >
              Use Case: Supply chain optimization and digital marketplace use
              case
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              Twiga Foods is a Kenyan based organization that incorporates
              Google Cloud-based solutions and AI-powered platforms to
              streamline agricultural supply chains. The use of cloud-based AI
              platforms has improved Kenya’s and regional agricultural supply
              chain by leveraging technology to connect smallholder farmers with
              urban retailers. With the use of local level data and AI, Twiga
              streamlines the distribution of fresh produce, enhances supply
              efficiency, and reduces food waste. Twiga also uses data analytics
              models to analyze market demand, compute optimal pricing
              strategies, and manage its logistics. The application of these
              tools ensures local farmers are fairly compensated without
              increasing the cost of food access to urban vendors.
            </Typography>
            <Typography
              variant="body1"
              paddingBottom={{ xs: "5%", sm: "2%" }}
              lineHeight={1.75}
              color={"#4f4f4f"}
            >
              Investments in initiatives like Twiga Food would accelerate
              resilient food systems in megacities and secondary cities across
              Africa without impoverishing rural areas. Fair compensations of
              farm gate suppliers and agricultural produce would increase
              financial assets of local farmers. A potential multiplier effect
              of better compensation for farmers is an increase in the labor
              force engagement in Agriculture. Investments in initiatives like
              Twiga food will also improve human capital, which is an important
              determinant of long-term economic growth. A key theory of change
              at AIR Fund is that while evidence on the impact of institutional
              reforms on long run economic growth, improved human capital
              supports long term economic growth and better institutions.
            </Typography>
          </Box>
        </Box>
      </Container>
      <Box bgcolor={"#213555"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default Twiga;
